// extracted by mini-css-extract-plugin
export default {"container":"InfoBanner_container__pWZ7w","item":"InfoBanner_item__0BHlF","label":"InfoBanner_label__RjSCX","value":"InfoBanner_value__vFA+v","icon":"InfoBanner_icon__5a+S1"};